import { Activity, EntityEnum } from '@goldcast/api/backend';

export const isEntityScreenshare = (entity: EntityEnum) => {
  return entity === 'aligned_screenshare_feed';
};

export const isEntityUserFeed = (entity: EntityEnum) => {
  return entity === 'aligned_user_feed';
};

export const isEntitySharedVideo = (entity: EntityEnum) => {
  return entity === 'aligned_video_feed';
};

export const isActivityScreenshare = (activity: Activity) => {
  return isEntityScreenshare(activity.entity);
};

export const isActivityUserFeed = (activity: Activity) => {
  return isEntityUserFeed(activity.entity);
};

export const isActivitySharedVideo = (activity: Activity) => {
  return isEntitySharedVideo(activity.entity);
};
